import request from '../utils/request';
import Vue from 'vue';

var url = process.env.VUE_APP_API_URL;
var urlEs = process.env.VUE_APP_ES_URL;

export default {
  uploadImgUrl: url + '/meditation/admin/uploadFile',
  uploadImgs: url + '/api/admin/uploads',
  imageHost: 'https://image.talk2best.cn',
};
// 登录
export const denglu = (query) => {
  return request({
    // url: url + '/api/manage/login',
    url: url + '/meditation/admin/login',
    method: 'post',
    data: query,
  });
};
// 查询菜单树
export const getAllMenu = (query) => {
  return request({
    url: url + '/api/manage/allMenu',
    method: 'get',
    data: query,
  });
};

// -----------文章--------
// 文章列表
export const getArticleList = (query) => {
  return request({
    url: url + '/api/article_manage/article/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 审核文章
export const articleAudit = (query) => {
  return request({
    url: url + '/api/article_manage/article/audit',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 删除文章
export const delArticle = (query) => {
  return request({
    url: url + '/api/article_manage/article/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//文章详情
export const articleDetail = (query) => {
  return request({
    url: url + '/api/article_manage/article/detail',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 获取文章信息byIds
export const getByIds = (query) => {
  return request({
    url: url + '/api/article_manage/article/getByIds',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 文章列表(分类管理页)
export const getList4class = (query) => {
  return request({
    url: url + '/api/article_manage/article/list4class',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 文章列表(弹框)
export const getList4Pop = (query) => {
  return request({
    url: url + '/api/article_manage/article/list4Pop',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 下线文章
export const getOffline = (query) => {
  return request({
    url: url + '/api/article_manage/article/offline',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//发布(上线)文章
export const publishArticle = (query) => {
  return request({
    url: url + '/api/article_manage/article/publish',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//保存文章
export const saveArticle = (query) => {
  return request({
    url: url + '/api/article_manage/article/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//更新文章视频切片
export const updateSliceInfo = (query) => {
  return request({
    url: url + '/api/article_manage/article/updateSliceInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// -------------文章部分------
// -------------文章评论------
//运营者回复_管理端
export const addArticleRemark = (query) => {
  return request({
    url: url + '/api/article_manage/manage/addArticleRemark',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//获取全部文章评论_管理端
export const getAllComments = (query) => {
  return request({
    url: url + '/api/article_manage/manage/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//运营者回复_管理端
export const popRemark = (query) => {
  return request({
    url: url + '/api/article_manage/manage/popRemark',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//发表/屏蔽/删除评论_管理端
export const updateRemarkStatus = (query) => {
  return request({
    url: url + '/api/article_manage/manage/updateRemarkStatus',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// -------------end------

//---------------专题部分-----------
// 删除专题
export const delSubject = (query) => {
  return request({
    url: url + '/api/article_manage/subject/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 专题详情
export const subjectDetail = (query) => {
  return request({
    url: url + '/api/article_manage/subject/detail',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//专题列表
export const getSubjectList = (query) => {
  return request({
    url: url + '/api/article_manage/subject/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//类目添加专题列表
export const getSubjectList1 = (query) => {
  return request({
    url: url + '/api/article_manage/subject/list4Pop',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 下线专题
export const subjectOffline = (query) => {
  return request({
    url: url + '/api/article_manage/subject/offline',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 发布(上线)专题
export const publishSubject = (query) => {
  return request({
    url: url + '/api/article_manage/subject/publish',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 保存专题
export const saveSubject = (query) => {
  return request({
    url: url + '/api/article_manage/subject/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//--------------专题部分--------------

//---------------分类部分----------------
// 删除分类
export const deleteClassification = (query) => {
  return request({
    url: url + '/api/article_manage/classification/deleteClassification',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 获取全部分类(带层级结构)
export const getAllClassification = (query) => {
  return request({
    url: url + '/api/article_manage/classification/getAll',
    method: 'get',
    data: {},
  });
};
// 保存分类
export const saveClassification = (query) => {
  return request({
    url: url + '/api/article_manage/classification/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//-----------------分类部分--------------

//------------------类目部分-------------
// 删除类目
export const deleteCategory = (query) => {
  return request({
    url: url + '/api/article_manage/category/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 类目详情
export const categoryDetail = (query) => {
  return request({
    url: url + '/api/article_manage/category/detail',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//类目信息---多个 ids 的数据详情
export const categoryDetailByIds = (query) => {
  return request({
    url: url + '/api/article_manage/category/details',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 类目列表
export const getCategoryList = (query) => {
  return request({
    url: url + '/api/article_manage/category/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 类目列表(弹框下拉框)
export const getCategorylist4All = (query) => {
  return request({
    url: url + '/api/article_manage/category/list4All',
    method: 'get',
    data: {
      data: query,
    },
  });
};
// 下线类目
export const offlineCategory = (query) => {
  return request({
    url: url + '/api/article_manage/category/offline',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 发布(上线)类目
export const publishCategory = (query) => {
  return request({
    url: url + '/api/article_manage/category/publish',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 保存类目
export const saveCategory = (query) => {
  return request({
    url: url + '/api/article_manage/category/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//------------类目部分---------

//-------------直播部分---------
// 添加/修改直播分类
export const addLiveCategory = (query) => {
  return request({
    url: url + '/api/live_manage/addLiveCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 创建/修改直播
export const createOrEditLive = (query) => {
  return request({
    url: url + '/api/live_manage/createOrEditLive',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 删除直播
export const deleteLive = (query) => {
  return request({
    url: url + '/api/live_manage/deleteLive',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 删除直播分类
export const deleteLiveCategory = (query) => {
  return request({
    url: url + '/api/live_manage/deleteLiveCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 获取所有直播分类(树型结构)
export const getLiveCategory = (query) => {
  return request({
    url: url + '/api/live_manage/getLiveCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//直播详情
export const getLiveDetail = (query) => {
  return request({
    url: url + '/api/live_manage/getLiveDetail',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 获取直播列表
export const getLiveList = (query) => {
  return request({
    url: url + '/api/live_manage/getLiveList',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 根据id获取直播列表
export const getLiveListByIds = (query) => {
  return request({
    url: url + '/api/live_manage/getLiveListByIds',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 结束直播
export const endLive = (query) => {
  return request({
    url: url + '/api/live_manage/endLive',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 下线直播
export const offlineLive = (query) => {
  return request({
    url: url + '/api/live_manage/offlineLive',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 发布直播
export const publishLive = (query) => {
  return request({
    url: url + '/api/live_manage/publishLive',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------

//------------用户管理---------
//查询学校列表
export const findAllSchool = (query) => {
  return request({
    url: url + '/api/user_manage/findAllSchool',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//获取用户增长数
export const getUserGrowthData = (query) => {
  return request({
    url: url + '/api/user_manage/getUserGrowthData',
    method: 'get',
    data: {
      data: query,
    },
  });
};
//查询用户详情
export const queryUserDetails = (query) => {
  return request({
    url: url + '/api/user_manage/queryUserDetails',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//查询用户列表
export const queryUserInfo = (query) => {
  return request({
    url: url + '/api/user_manage/queryUserInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 设置管理员
export const setAdmin = (query) => {
  return request({
    url: url + '/api/user_manage/setAdmin',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//更新用户信息
export const updateUserDetail = (query) => {
  return request({
    url: url + '/api/user_manage/updateUserDetail',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//------------- end---------

//------------频道配置---------
//删除频道
export const deleteChannel = (query) => {
  return request({
    url: url + '/meditation/admin/deleteBanner',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑频道
export const editChannel = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/channel/editChannel',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//频道已选择推广位列表
export const getChannelContent = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/channel/getChannelContent',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//频道列表
export const getChannelList = (query) => {
  return request({
    url: url + '/meditation/admin/allBanner',
    method: 'post',

      data: query,

  });
};
//banner上线下线
export const ChannelListupdate = (query) => {
  return request({
    url: url + '/meditation/admin/changeBannerStatus',
    // url:'http://192.168.3.159:18086/meditation/admin/changeBannerStatus',
    method: 'post',

      data: query,

  });
};
//发布/下线频道
export const releaseChannel = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/channel/release',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//频道选择推广位，保存
export const saveChooseSpreadSpace = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/channel/saveChooseSpreadSpace',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//banner+推广位列表
export const spreadSpaceList = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/channel/spreadSpaceList',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------
//------------按钮配置---------
//删除
export const deleteButton = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/button/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑
export const editButton = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/button/edit',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//列表
export const getButtonList = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/button/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//发布/下线
export const releaseButton = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/button/release',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------
//------------弹窗配置---------
//删除
export const deletePopup = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/popup/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑
export const editPopup = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/popup/edit',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//列表
export const getPopupList = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/popup/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//发布/下线
export const releasePopup = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/popup/release',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------

//------------搜索推荐---------
//删除
export const deleteRecommand = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/recommand/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑
export const editRecommand = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/recommand/edit',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//列表
export const getRecommandList = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/recommand/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//发布/下线
export const releaseRecommand = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/recommand/release',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------
//------------搜索配置---------
//删除
export const deleteSearch = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/search/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑
export const editSearch = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/search/edit',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//列表
export const getSearchList = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/search/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//发布/下线
export const releaseSearch = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/search/release',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------

//------------闪屏配置---------
//删除
export const deleteScreen = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/screen/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑
export const editScreen = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/screen/edit',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//列表
export const getScreenList = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/screen/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//发布/下线
export const releaseScreen = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/screen/release',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------
//------------站内信配置---------
//删除
export const deleteMessage = (query) => {
  return request({
    url: url + '/api/user_manage/message/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑
export const editMessage = (query) => {
  return request({
    url: url + '/api/user_manage/message/edit',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//列表
export const getMessageList = (query) => {
  return request({
    url: url + '/api/user_manage/message/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------

//------------用户操作日志---------
//添加
export const addLog = (query) => {
  return request({
    url: url + '/api/operate_log/addLog',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//列表
export const queryLog = (query) => {
  return request({
    url: url + '/api/operate_log/queryLog',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------
//------------系统管理-平台用户管理---------
//批量新增客服反馈
export const addFeedBackBatch = (query) => {
  return request({
    url: url + '/api/manage/userManagement/addFeedBackBatch',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑客服反馈
export const editFeedBack = (query) => {
  return request({
    url: url + '/api/manage/userManagement/editFeedBack',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//新增客服反馈分类
export const addFeedBackCategory = (query) => {
  return request({
    url: url + '/api/manage/userManagement/addFeedBackCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑客服反馈分类
export const editFeedBackCategory = (query) => {
  return request({
    url: url + '/api/manage/userManagement/editFeedBackCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//查询客服反馈
export const findFeedBack = (query) => {
  return request({
    url: url + '/api/manage/userManagement/findFeedBack',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//查询客服反馈分类
export const findFeedBackCategory = (query) => {
  return request({
    url: url + '/api/manage/userManagement/findFeedBackCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//添加反馈历史记录
export const addFeedBackHistory = (query) => {
  return request({
    url: url + '/api/manage/userManagement/addFeedBackHistory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//新增用户组
export const addGroup = (query) => {
  return request({
    url: url + '/api/manage/userManagement/addGroup',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//查询用户组列表
export const queryGroup = (query) => {
  return request({
    url: url + '/api/manage/userManagement/queryGroup',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//查询用户组详情
export const queryGroupDetails = (query) => {
  return request({
    url: url + '/api/manage/userManagement/queryGroupDetails',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//修改用户组
export const updateGroup = (query) => {
  return request({
    url: url + '/api/manage/userManagement/updateGroup',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//新增用户
export const addUser = (query) => {
  return request({
    url: url + '/api/manage/userManagement/addUser',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑用户
export const updateUser = (query) => {
  return request({
    url: url + '/api/manage/userManagement/updateUser',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//新增标签
export const addLabel = (query) => {
  return request({
    url: url + '/api/manage/userManagement/addLabel',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑标签
export const editLabel = (query) => {
  return request({
    url: url + '/api/manage/userManagement/editLabel',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//查询标签列表
export const queryLabel = (query) => {
  return request({
    url: url + '/api/manage/userManagement/queryLabel',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//新增敏感词
export const addSensitive = (query) => {
  return request({
    // url: url + '/api/manage/userManagement/addSensitive',
    url: url + '/meditation/admin/addSensitive',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//校验敏感词名称是否重复
export const checkSensitiveWord = (query) => {
  return request({
    url: url + '/api/manage/userManagement/checkSensitiveWord',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//编辑敏感词
export const editSensitive = (query) => {
  return request({
    url: url + '/meditation/admin/addSensitive',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//查询敏感词 !!
export const querySensitive = (query) => {
  return request({
    // url: url + '/api/manage/userManagement/querySensitive',
    url:  url + '/meditation/admin/allSensitive',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//查询全部分类
export const queryAllCategory = (query) => {
  return request({
    url: url + '/api/manage/userManagement/queryAllCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//queryFeedBackHistory
export const queryFeedBackHistory = (query) => {
  return request({
    url: url + '/api/manage/userManagement/queryFeedBackHistory',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//查询用户列表
export const queryUser = (query) => {
  return request({
    url: url + '/api/manage/userManagement/queryUser',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//查询用户权限
export const queryUserAuth = (query) => {
  return request({
    url: url + '/api/manage/userManagement/queryUserAuth',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//---------end---------
//------------课程管理---------
//获取总课程列表
export const getCourseList = (query) => {
  return request({
    url: url + '/api/course_manage/course/selectList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取课程详情
export const getCourseInfo = (query) => {
  return request({
    url: url + '/api/course_manage/course/getInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 课程保存/修改
export const saveCourse = (query) => {
  return request({
    url: url + '/api/course_manage/course/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取课程全部章节+课文信息
export const selectChapterInfo = (query) => {
  return request({
    url: url + '/api/course_manage/course/selectChapterInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 添加单元和课文
export const addChapterText = (query) => {
  return request({
    url: url + '/api/course_manage/course/addChapterText',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 分页查询单元
export const selectChapter = (query) => {
  return request({
    url: url + '/api/course_manage/course/selectChapter',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 分页查询课文
export const selectChapterTexts = (query) => {
  return request({
    url: url + '/api/course_manage/course/selectChapterTexts',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//音视频课审核
export const courseExamine = (query) => {
  return request({
    url: url + '/api/course_manage/course/examine',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 课程上线/下线
export const coursePublish = (query) => {
  return request({
    url: url + '/api/course_manage/course/publish',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 课程删除/恢复
export const courseDelete = (query) => {
  return request({
    url: url + '/api/course_manage/course/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取课文列表
export const getTextList = (query) => {
  return request({
    url: url + '/api/course_manage/courseText/selectList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取课程课文详情
export const getTextInfo = (query) => {
  return request({
    url: url + '/api/course_manage/courseText/getInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 课文保存/修改
export const saveText = (query) => {
  return request({
    url: url + '/api/course_manage/courseText/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 课文上线/下线
export const textPublish = (query) => {
  return request({
    url: url + '/api/course_manage/courseText/publish',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 课文删除/恢复
export const textDelete = (query) => {
  return request({
    url: url + '/api/course_manage/courseText/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 运营者回复_管理端
export const addTextRemark = (query) => {
  return request({
    url: url + '/api/course_manage/manage/addCourseRemark',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取课文留言_管理端
export const getTextMsg = (query) => {
  return request({
    url: url + '/api/course_manage/manage/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 置顶留言-取消置顶_管理端
export const textMsgPop = (query) => {
  return request({
    url: url + '/api/course_manage/manage/popRemark',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取留言表中课文所属课程列表_管理端
export const getMsgCoursesList = (query) => {
  return request({
    url: url + '/api/course_manage/manage/remark/getCourses',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 发表/屏蔽/删除留言_管理端
export const textMsgUpdata = (query) => {
  return request({
    url: url + '/api/course_manage/manage/updateRemarkStatus',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 查询班级
export const queryClass = (query) => {
  return request({
    url: url + '/api/user_manage/manageClass/queryClass',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 获取总课程列表
export const selectAllList = (query) => {
  return request({
    url: url + '/api/course_manage/course/selectAllList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//---------end---------
//------------课程管理-分类管理---------

//---------end---------
//------------APP推广配置-推广位配置-（金刚区，直播，文章列表，文章专题，文章卡片，强推课程，分类课程）---------
//删除-（通用）
export const deleteSpreadSpace = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/spreadSpace/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//详情-（金刚区，直播，文章列表，文章专题，文章卡片，强推课程，课程列表）
export const spreadSpaceDetail1 = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/spreadSpace/detail1',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//详情-（分类课程）
export const spreadSpaceDetail2 = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/spreadSpace/detail2',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑-（金刚区，直播，文章列表，文章专题，强推课程）
export const spreadSpaceEdit1 = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/spreadSpace/edit1',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑-（文章卡片）
export const spreadSpaceEdit2 = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/spreadSpace/edit2',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑-（分类课程）
export const spreadSpaceEdit3 = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/spreadSpace/edit3',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//编辑-（文章类目）
export const spreadSpaceEdit4 = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/spreadSpace/edit4',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//列表-（金刚区，直播，文章列表，文章专题，文章卡片，强推课程，分类课程）
export const getSpreadSpaceList = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/spreadSpace/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//发布/下线-（通用）
export const spreadSpaceRelease = (query) => {
  return request({
    url: url + '/api/zgconfig_manage/spreadSpace/release',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//---------end---------

//---------数字课程管理-课程资源管理---------
//获取课程资源详情
export const getCourceInfo = (query) => {
  return request({
    url: url + '/api/course_manage/resource/getInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//资源保存/修改
export const saveCource = (query) => {
  return request({
    url: url + '/api/course_manage/resource/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//获取已删除的资源列表
export const selectDelList = (query) => {
  return request({
    url: url + '/api/course_manage/resource/selectDelList',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//获取资源列表
export const getSelectCourseList = (query) => {
  return request({
    url: url + '/api/course_manage/resource/selectList',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//通过分类获取资源列表
export const selectListByCategory = (query) => {
  return request({
    url: url + '/api/course_manage/resource/selectListByCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//资源视频切片状态
export const updateSliceStatus = (query) => {
  return request({
    url: url + '/api/course_manage/resource/updateSliceStatus',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//资源删除(支持批量)
export const deleteCourseList = (query) => {
  return request({
    url: url + '/api/course_manage/resource/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//资源审核
export const examineCourse = (query) => {
  return request({
    url: url + '/api/course_manage/resource/examine',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//资源上线/下线
export const publishCourse = (query) => {
  return request({
    url: url + '/api/course_manage/resource/publish',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//获取所有分类(树型结构)
export const getCourseCategory = (query) => {
  return request({
    url: url + '/api/course_manage/category/allCategory',
    method: 'get',
    data: {
      data: query,
    },
  });
};
//删除分类
export const deleteCourseCategory = (query) => {
  return request({
    url: url + '/api/course_manage/category/deleteCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//添加/修改分类
export const addCourseCategory = (query) => {
  return request({
    url: url + '/api/course_manage/category/addCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//-----------意见反馈---------
//删除意见反馈
export const deleteSuggest = (query) => {
  return request({
    url: url + '/api/manage/suggest/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//意见反馈详细信息
export const suggestDetail = (query) => {
  return request({
    url: url + '/api/manage/suggest/detail',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 意见反馈列表
export const suggestList = (query) => {
  return request({
    url: url + '/api/manage/suggest/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 回复意见反馈
export const suggestReply = (query) => {
  return request({
    url: url + '/api/manage/suggest/reply',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------
//-----------用户工作台---------
//编辑快捷导航
export const editQuickNavigation = (query) => {
  return request({
    url: url + '/api/manage/editQuickNavigation',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//获取菜单列表
export const getMenuList = (query) => {
  return request({
    url: url + '/api/manage/getMenuList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 用户工作台首页
export const userWorkSpace = (query) => {
  return request({
    url: url + '/api/manage/userWorkSpace',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//获取访问量前10的文章
export const getTopTenArticle = (query) => {
  return request({
    url: url + '/api/article_manage/article/getTopTenArticle',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//获取浏览数前十名的浏览数据
export const getTopCourseWatchDate = (query) => {
  return request({
    url: url + '/api/course_manage/course/getTopCourseWatchDate',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------

// 获取学校列表
export const getSchoolList = (query) => {
  return request({
    url: url + '/api/user_manage/school/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获启用/禁用学校
export const updateSchoolFlg = (query) => {
  return request({
    url: url + '/api/user_manage/school/updateSchoolFlg',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 管理员列表
export const getSchoolAdmin = (query) => {
  return request({
    url: url + '/api/user_manage/school/manageList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 管理员列表
export const deleteSchoolAdmin = (query) => {
  return request({
    url: url + '/api/user_manage/school/deleteManage',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 添加学校
export const addSchool = (query) => {
  return request({
    url: url + '/api/user_manage/school/addSchool',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 编辑学校
export const editSchool = (query) => {
  return request({
    url: url + '/api/user_manage/school/editSchool',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 学校合并
export const mergeSchool = (query) => {
  return request({
    url: url + '/api/user_manage/school/mergeSchool',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 认证信息列表
export const manageExamList = (query) => {
  return request({
    url: url + '/api/user_manage/manageExam/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 认证信息审批
export const manageExam = (query) => {
  return request({
    url: url + '/api/user_manage/manageExam/exam',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取地址信息
export const getAddress = (query) => {
  return request({
    url: url + '/api/user_manage/address',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 教师认证列表
export const teachExamList = (query) => {
  return request({
    url: url + '/api/user_manage/teacherManage/allTeacher',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//-----------文章留言---------

//-----------资源管理-题库管理---------

// 删除试题
export const deleteQuestion = (query) => {
  return request({
    url: url + '/api/zgsource_manage/question/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 试题详情
export const detailQuestion = (query) => {
  return request({
    url: url + '/api/zgsource_manage/question/detail',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 试题列表
export const listQuestion = (query) => {
  return request({
    url: url + '/api/zgsource_manage/question/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 标签列表（下拉）
export const list4Select = (query) => {
  return request({
    url: url + '/api/zgsource_manage/label/list4Select',
    method: 'get',
    data: query,
  });
};

// 试题列表（弹窗）
export const questionFind = (query) => {
  return request({
    url: url + '/api/zgsource_manage/question/questionFind',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 删除试题（批量）
export const batchDelete = (query) => {
  return request({
    url: url + '/api/zgsource_manage/question/batchDelete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 保存试题
export const saveQuestion = (query) => {
  return request({
    url: url + '/api/zgsource_manage/question/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 批量保存试题
export const batchSaveQuestion = (query) => {
  return request({
    url: url + '/api/zgsource_manage/question/batchSave',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取所有分类(树型结构)
export const zgsourceAllCategory = (query) => {
  return request({
    url: url + '/api/zgsource_manage/category/allCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 删除分类
export const zgDeleteCategory = (query) => {
  return request({
    url: url + '/api/zgsource_manage/category/deleteCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 添加分类
export const zgAddCategory = (query) => {
  return request({
    url: url + '/api/zgsource_manage/category/addCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//-----------数字课程管理-讲师管理---------

// 删除讲师
export const deleteLecturer = (query) => {
  return request({
    url: url + '/api/course_manage/lecturer/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 讲师详情
export const detailLecturer = (query) => {
  return request({
    url: url + '/api/course_manage/lecturer/getInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 讲师列表
export const listLecturer = (query) => {
  return request({
    url: url + '/api/course_manage/lecturer/selectList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 保存试题
export const saveLecturer = (query) => {
  return request({
    url: url + '/api/course_manage/lecturer/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//-----------数字课程管理-考试管理---------

// 删除考试
export const deleteExam = (query) => {
  return request({
    url: url + '/api/course_manage/exam/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 考试详情
export const detailExam = (query) => {
  return request({
    url: url + '/api/course_manage/exam/getInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 考试列表
export const listExam = (query) => {
  return request({
    url: url + '/api/course_manage/exam/selectList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 保存考试
export const saveExam = (query) => {
  return request({
    url: url + '/api/course_manage/exam/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 试卷列表
export const platformPaperList = (query) => {
  return request({
    url: url + '/api/zgsource_manage/platformPaper/platformPaperList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//-----------资源管理-资源管理---------

// 资源删除/恢复
export const deleteResource = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resource/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取资源详情
export const getInfoResource = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resource/getInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 资源上线/下线
export const publishResource = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resource/publish',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 资源保存/修改
export const saveResource = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resource/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取已删除的资源列表
export const selectDelListResource = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resource/selectDelList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取资源列表
export const selectListResource = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resource/selectList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 资源视频切片状态
export const updateSliceStatusResource = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resource/updateSliceStatus',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// ----------资源管理-资源统计分析-------
// 热门资源引用统计
export const selectHotStat = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resourceAnalysis/selectHotStat',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 资源删除/恢复(批量)
export const batchDeleteResource = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resource/batchDelete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 资源统计页面
export const selectStat = (query) => {
  return request({
    url: url + '/api/zgsource_manage/resourceAnalysis/selectStat',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 获取二维码登录标识
export const getToken = (query) => {
  return request({
    url: url + '/api/manage/getToken',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 获取移动端用户信息
export const invokeFrontUser = (query) => {
  return request({
    url: url + '/api/manage/frontLogin',
    method: 'post',
    data: {
      data: query,
    },
  });
};
// 添加Banner
export const getAddBanner = (query) => {
  return request({
    url: url + '/meditation/admin/addBanner',
    method: 'post',
      data: query,
  });
};
// 编辑Banner
export const getUpateBanner = (query) => {
  return request({
    url: url + '/meditation/admin/editBanner',
    method: 'post',
      data: query,
  });
};
// 添加Banner跳转音频
export const getJumpBanner = (query) => {
  return request({
    url: url + '/meditation/admin/audioList',
    method: 'post',

      data: query,

  });
};
//上下线Banner
export const BannerTo = (query) => {
  return request({
    url: url + '/meditation/admin/changeBannerStatus',
    method: 'post',
      data: query,
  });
};
//删除Banner
export const BannerDelete = (query) => {
  return request({
    url: url + '/meditation/admin/deleteBanner',
    method: 'post',
    data: query,
  });
};
//提交Banner
export const subBanner = (query) => {
  return request({
    url: url + '/meditation/admin/commitBanner',
    method: 'post',

    data: query,

  });
};
//音乐列表
export const AddMusic = (query) => {
  return request({
    url: url + '/meditation/admin/addAudio',
    method: 'post',

    data: query,

  });
};
//音乐搜索
export const fenlieMusic = (query) => {
  return request({
    url: url + '/meditation/admin/getCategoryList',
    method: 'post',

    data: query,

  });
};
//音乐大列表
export const MusicList = (query) => {
  return request({
    url: url + '/meditation/admin/getAllAudio',
    method: 'post',

    data: query,

  });
};
//音乐编辑列表
export const MusicUpdate = (query) => {
  return request({
    url: url + '/meditation/admin/getAudioById',
    method: 'post',

    data: query,

  });
};
//音乐编辑列表回显
export const MusicToUpdate = (query) => {
  return request({
    url: url + '/meditation/admin/editAudio',
    method: 'post',

    data: query,

  });
};
//音乐列表删除
export const MusicDelete = (query) => {
  return request({
    url: url + '/meditation/admin/deleteAudio',
    method: 'post',

    data: query,

  });
};
//添加敏感词
export const  AddSensitive = (query) => {
  return request({
    url: url + '/meditation/admin/addSensitive',
    method: 'post',

    data: query,

  });
};
//删除敏感词
export const  DeleteSensitive = (query) => {
  return request({
    url: url + '/meditation/admin/deleteSensitive',
    method: 'post',

    data: query,

  });
};
//敏感词列表
export const  SensitiveList = (query) => {
  return request({
    url: url + '/meditation/admin/allSensitive',
    method: 'post',

    data: query,

  });
};
//审核大列表
export const  SchemaList = (query) => {
  return request({
    url: url + '/meditation/admin/getAllSchema',
    method: 'post',

    data: query,

  });
};
//审核修改
export const  Schemaupdate = (query) => {
  return request({
    url: url + '/meditation/admin/changeSchemaStatus',
    method: 'post',
    data: query,
  });
};
//审核删除
export const  Schemadelete = (query) => {
  return request({
    url: url + '/meditation/admin/deleteSchemaStatus',
    method: 'post',
    data: query,
  });
};
//首页列表
export const  indexList = (query) => {
  return request({
    url: url + '/meditation/admin/index',
    method: 'post',
    data: query,
  });
};
//分类列表
export const  classifyList = (query) => {
  return request({
    url: url + '/meditation/admin/queryCategory',
    method: 'post',
    data: query,
  });
};
//添加分类
export const  Addclassify = (query) => {
  return request({
    url: url + '/meditation/admin/addCategory',
    method: 'post',
    data: query,
  });
};
//编辑分类
export const  editclassify = (query) => {
  return request({
    url: url + '/meditation/admin/editCategory',
    method: 'post',
    data: query,
  });
};

//新增闪屏
export const  addFlash = (query) => {
  return request({
    url: url + '/meditation/admin/addWelcome',
    method: 'post',
    data: query,
  });
};
//闪屏列表页
export const  flashList = (query) => {
  return request({
    url: url + '/meditation/admin/allWlecome',
    method: 'post',
    data: query,
  });
};
//闪屏上下线
export const  flashchange = (query) => {
  return request({
    url: url + '/meditation/admin/changeWelcomeStatus',
    method: 'post',
    data: query,
  });
};
//闪屏编辑
export const  flashEdit = (query) => {
  return request({
    url: url + '/meditation/admin/editWelcome',
    method: 'post',
    data: query,
  });
};
//闪屏提交
export const  flashSubmit = (query) => {
  return request({
    url: url + '/meditation/admin/commitWecome',
    method: 'post',
    data: query,
  });
};
//闪屏删除
export const  flashDelete = (query) => {
  return request({
    url: url + '/meditation/admin/deleteWelcome',
    method: 'post',
    data: query,
  });
};
//返回用户上传数量
export const  returnUploadNum = (query) => {
  return request({
    url: url + '/meditation/admin/getMaxFileUpload',
    method: 'post',
    data: query,
  });
};
//上传用户上传数量
export const  uploadNum = (query) => {
  return request({
    url: url + '/meditation/admin/changeMaxFileUpload',
    method: 'post',
    data: query,
  });
};
//用户列表
export const  userList = (query) => {
  return request({
    url: url + '/meditation/admin/showUserInfo',
    method: 'post',
    data: query,
  });
};
//用户启用禁用
export const  userOpenClose = (query) => {
  return request({
    url: url + '/meditation/admin/updateUserStatus',
    method: 'post',
    data: query,
  });
};
//用户收听
export const  userListen = (query) => {
  return request({
    url: url + '/meditation/record/myReport',
    method: 'post',
    data: query,
  });
};
//用户睡眠记录
export const  userSleepRecord = (query) => {
  return request({
    url: url + '/meditation/admin/queryRecordAudio',
    method: 'post',
    data: query,
  });
};
//用户提交
export const  userSubmit = (query) => {
  return request({
    url: url + '/meditation/admin/commitUserBaseInfo',
    method: 'post',
    data: query,
  });
};
//删除用户
export const  userDelete = (query) => {
  return request({
    url: url + '/meditation/admin/deleteUser',
    method: 'post',
    data: query,
  });
};
//修改密码提交
export const  passwordSubmit = (query) => {
  return request({
    url: url + '/meditation/admin/updateUserPwd',
    method: 'post',
    data: query,
  });
};
//修改密码返回密保问题
export const  passwordReturn = (query) => {
  return request({
    url: url + '/meditation/admin/showUserInfo',
    method: 'post',
    data: query,
  });
};












